import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ResourceConfig } from './resource-service.service';

export function provideResourceService(config: ResourceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'resourceConfig', useValue: config }
  ]);
}
